import React, {useEffect} from 'react';
import {Button} from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import {HelpCircle, Mail} from 'lucide-react';
import {getCalApi} from "@calcom/embed-react";
import {useUser} from "@clerk/clerk-react";

const calLink = 'achyutatkay/kay.ai-office-hours-w-achyut?duration=15';

const HelpDialog = () => {
  const {user} = useUser();

  const initiateCal = async () => {
    const cal = await getCalApi();
    cal("ui", {
      styles: {
        branding: {brandColor: "#FFE100"},
      }
    });
  }

  useEffect(() => {
    initiateCal();
  }, []);

  const dataCalConfig = {
    email: user?.primaryEmailAddress?.emailAddress,
    name: user?.fullName,
    theme: 'light',
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="gap-2 w-full" size="sm" variant="link">
          <HelpCircle className="h-4 w-4"/>
          Need Help?
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md bg-white">
        <DialogHeader>
          <DialogTitle>Need Help?</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-gray-600">
            {`Have questions or need assistance? We're here for you! Contact us at:`}
          </p>
          <div className="flex items-center gap-2 text-sm">
            <Mail className="h-4 w-4 text-gray-500"/>
            <a
              className="font-medium text-blue-600 hover:text-blue-500 transition-colors"
              href="mailto:human@kay.ai"
            >
              human@kay.ai
            </a>
          </div>
          <p className="text-sm text-gray-600">
            {`Our team will respond as soon as possible to assist with any inquiries or concerns.`}
          </p>
          <p className='text-sm text-gray-600 space-x-2'>
            <span>
              {`Prefer a call? Schedule a 15-minute chat with Achyut (CTO) here:`}
            </span>
            <button
              className='text-blue-600 hover:text-blue-500 transition-colors'
              data-cal-config={JSON.stringify(dataCalConfig)}
              data-cal-link={calLink}
            >
              Book a Call
            </button>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HelpDialog;
